import { jsx } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
import { SurveyCarousel } from "../SurveyCarousel.js";
function SurveysPart({ part, allParts }) {
  var _a, _b;
  const suppressOutput = allParts.some((p) => p.type === "data-survey-section");
  if (isCallState(part.state)) return /* @__PURE__ */ jsx("div", { className: "concierge-loading", children: "Loading surveys..." });
  if (suppressOutput) return null;
  if (isOutputState(part.state) && ((_b = (_a = part.output) == null ? void 0 : _a.surveys) == null ? void 0 : _b.length) > 0) {
    return /* @__PURE__ */ jsx(SurveyCarousel, { surveys: part.output.surveys });
  }
  return null;
}
export {
  SurveysPart
};
//# sourceMappingURL=SurveysPart.js.map
